/** @graphql cc **/

import gql from 'graphql-tag';

export const ContentAndHeaderQuery = gql`
	query ContentAndHeaderQuery(
		$contentId: ID!
		$spaceKey: String = null
		$versionOverride: Int = null
		$embeddedContentRender: String = null
		$limit: Int = 4
		$useNewContentTopper: Boolean = false
	) {
		content(
			id: $contentId
			version: $versionOverride
			embeddedContentRender: $embeddedContentRender
		) {
			nodes {
				id
				type
				subType
				title
				history {
					createdBy {
						type
						displayName
						... on KnownUser {
							accountId
						}
						profilePicture {
							path
						}
					}
				}
				emojiTitlePublished: properties(key: "emoji-title-published") {
					nodes {
						id
						key
						value
						version {
							number
						}
					}
				}
				pageTitlePublished: properties(key: "page-title-property-published")
					@include(if: $useNewContentTopper) {
					nodes {
						id
						key
						value
						version {
							number
						}
					}
				}
				properties(keys: ["cover-picture-id-published", "editor"]) {
					nodes {
						id
						key
						value
						version {
							number
						}
					}
				}
				space {
					id
					key
					name
				}
				version {
					confRev
					message
					by {
						type
						displayName
						... on KnownUser {
							accountId
						}
						profilePicture {
							path
						}
					}
					friendlyWhen
					when
					number
					contentTypeModified
				}
				metadata {
					sourceTemplateEntityId
					lastModifiedDate
					frontend {
						fabricEditorSupported
						coverPictureWidth @include(if: $useNewContentTopper)
					}
				}
				body {
					dynamic {
						representation
						value
						content {
							# Do not fetch 'id' here, so this version number is stored within 'body'
							# in GQL cache, separately from the shared 'content:[id]' cache entry.
							# This number is used to identify the correct version of cached 'body'.
							version {
								number
							}
						}
						webresource {
							superbatch {
								tags {
									js
									css
								}
							}
							tags {
								js
								css
							}
						}
					}
				}
				appearancePublished: properties(key: "content-appearance-published") {
					nodes {
						id
						key
						value
						version {
							number
						}
					}
				}
			}
		}
		contentContributors(id: $contentId, limit: $limit) {
			count
			isCurrentUserContributor
			nodes {
				type
				displayName
				... on KnownUser {
					accountId
				}
				profilePicture {
					path
				}
			}
		}
		space(key: $spaceKey) {
			id
			theme {
				name
				themeKey
			}
			lookAndFeel {
				headings {
					key
					value
				}
				content {
					header {
						background
						backgroundAttachment
						backgroundBlendMode
						backgroundClip
						backgroundColor
						backgroundImage
						backgroundOrigin
						backgroundPosition
						backgroundRepeat
						backgroundSize
						borderRadius
						padding
					}
					screen {
						background
						backgroundColor
						backgroundImage
						backgroundPosition
						backgroundSize
						backgroundRepeat
						backgroundOrigin
						backgroundClip
						backgroundAttachment
						backgroundBlendMode
						layer {
							background
							backgroundColor
							backgroundImage
							backgroundPosition
							backgroundSize
							backgroundRepeat
							backgroundOrigin
							backgroundClip
							backgroundAttachment
							backgroundBlendMode
							width
							height
						}
						gutterTop
						gutterRight
						gutterBottom
						gutterLeft
					}
					container {
						background
						backgroundColor
						backgroundImage
						backgroundPosition
						backgroundSize
						backgroundRepeat
						backgroundOrigin
						backgroundClip
						backgroundAttachment
						backgroundBlendMode
						padding
						borderRadius
					}
				}
			}
			settings {
				routeOverrideEnabled
			}
		}
	}
`;
